const Imprint = () => {
	return (
		<div>
			Imprint
		</div>
	);
};

export default Imprint;
